/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {WinPresentationController} from "../WinPresentationController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Serial} from "../../Serial";
import {ScatterSymbol} from "../../symbol/ScatterSymbol";
import {Layers, SerialLayers} from "../../view/SerialLayers";
import {gsap} from "gsap";
import {XSplitSymbol} from "../../symbol/XSplitSymbol";
import {SerialSound} from "../../sound/SerialSound";

export class FreespinWinController extends WinPresentationController {

    constructor() {
        super("FreespinWinController", false);
    }

    protected hasWin():boolean {
        const data = Serial.model.parsedGameData;
        return !data.mode.includes(GameMode.FREESPIN) && data.nextMode.includes(GameMode.FREESPIN);
    }

    protected async createWinAnimation():Promise<any> {
        Serial.background.tweenDimmer(0.8, 0.2);
        const wall = new PIXI.Sprite(Serial.assetLoader.getTextures("fsintro/wall")[0]);
        wall.anchor.set(0.5);
        wall.position.set(360, 384);
        SerialLayers.getLayer(Layers.SCREENS)!.addChild(wall);
        Serial.model.parsedGameData.scatterPositions!.forEach((symId, reelId) => {
            if(reelId > 3) {
                return;
            }
            if(symId > -1) {
                const symbol = <ScatterSymbol>Serial.getSymbol(reelId, symId);
                symbol.playPoster();
            }
        });
        if(Serial.model.parsedGameData.scatterPositions![4] > -1) {
            const s2 = <XSplitSymbol>Serial.getSymbol(4, Serial.model.parsedGameData.scatterPositions![4]);
            s2.playPoster();
        }

        const light = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset('fsTransition'));
        light.autoUpdate = true;
        light.position.set(360, 384);
        SerialLayers.getLayer(Layers.SCREENS)!.addChild(light);
        light.state.setAnimation(0, "animation", false);
        SerialSound.soundPlayer.playTrack({name : SerialSound.FS_TRANSITION});
        SerialSound.fadeMusic(0, 1);
        const tl = gsap.timeline();
        tl.add(() => {Serial.xBetController.buttonsVisible = false});
        tl.add([
            gsap.to(SerialLayers.stage.scale, {x : 1.05, y : 1.05, duration : 2.4}),
            gsap.to(SerialLayers.stage.position, {x : -0.05 * 360, y : -0.05 * 360, duration : 2.4})
        ]);
        tl.add([
            gsap.to(SerialLayers.stage.scale, {x : 1.8, y : 1.8, duration : 0.067}),
            gsap.to(SerialLayers.stage.position, {x : -0.8 * 360, y : -0.8 * 360, duration : 0.067})
        ]);
        tl.add([
            gsap.to(SerialLayers.stage.scale, {x : 1.82, y : 1.82, duration : 0.4}),
            gsap.to(SerialLayers.stage.position, {x : -0.82 * 360, y : -0.82 * 360, duration : 0.4})
        ]);
        tl.add([
            gsap.to(SerialLayers.stage.scale, {x : 3.5, y : 3.5, duration : 0.067}),
            gsap.to(SerialLayers.stage.position, {x : -2.5 * 360, y : -2.5 * 360, duration : 0.067})
        ]);
        tl.add(gsap.to(this, {duration : 0.533}));
        tl.add(() => {
            wall.parent.removeChild(wall);
            wall.destroy();
            light.state.clearTrack(0);
            light.skeleton.setToSetupPose();
            light.state.setEmptyAnimation(0, 0);
            light.parent.removeChild(light);
            light.destroy();
            Serial.model.parsedGameData.scatterPositions!.forEach((symId, reelId) => {
                if(reelId > 3) {
                    return;
                }
                if(symId > -1) {
                    const symbol = <ScatterSymbol>Serial.getSymbol(reelId, symId);
                    symbol.removePoster();
                }
            });
            if(Serial.model.parsedGameData.scatterPositions![4] > -1) {
                const s2 = <XSplitSymbol>Serial.getSymbol(4, Serial.model.parsedGameData.scatterPositions![4]);
                s2.removePoster();
            }
        });
        tl.add(() => {
            SerialLayers.stage.scale.set(1);
            SerialLayers.stage.position.set(0, 0);
        });
        await Promise.resolve(tl);
        await new Promise<void>(resolve => {
            Serial.freespinIntro.show(() => {
                Serial.keypadPlugin.setZeroBetSpinCounter(Serial.model.parsedGameData.freespinsLeft);
                resolve();
            });
        });
    }
}